module.exports = __webpack_public_path__ + "img/self_reflection_resize.fd8c1a53.jpg";